import {CancelTradeRatingsError} from './CancelTradeRatingsError.js'
import {EmptyTokenRatingsError} from './EmptyTokenRatingsError.js'
import {RatingsError} from './RatingsError.js'

export class RatingsErrorsFactory extends RatingsError {
  static cancelTradeRatingsError = () => new CancelTradeRatingsError()
  static emptyTokenRatingsError = () => new EmptyTokenRatingsError()
}
